export function NotFoundPage() {
  return <>404</>;
}
